import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "preferential_body_nr"
};
const _hoisted_3 = {
  class: "preferential_list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "indate"
};
const _hoisted_7 = {
  key: 1,
  style: {
    "display": "flex",
    "width": "100%",
    "align-items": "center",
    "justify-content": "center"
  }
};
const _hoisted_8 = {
  class: "dialog_body"
};
const _hoisted_9 = {
  class: "state"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "ka_info"
};
const _hoisted_12 = {
  class: "dialog_tip"
};
const _hoisted_13 = {
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_14 = {
  style: {
    "width": "40%"
  }
};
const _hoisted_15 = {
  style: {
    "color": "#000"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("h1", null, "我的卡片", -1)), _createElementVNode("div", _hoisted_3, [$setup.cardRecordsList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($setup.cardRecordsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: _cache[0] || (_cache[0] = () => {})
    }, [_createElementVNode("div", {
      style: _normalizeStyle('background:' + (item.status != '未激活' ? '#fff;' : '#EDEDED;') + 'border:' + (item.status != '未激活' ? '1px solid #13A4BF;' : '#none;'))
    }, [_createElementVNode("div", {
      class: "ka_img",
      onClick: $event => $setup.show_dialog(item)
    }, [_createElementVNode("img", {
      src: item.status != '未激活' ? item.imgUrl : item.unImgUrl,
      alt: ""
    }, null, 8, _hoisted_5), _createElementVNode("span", _hoisted_6, "有效期：" + _toDisplayString(item.status != '未激活' ? item.indate : '****'), 1)], 8, _hoisted_4)], 4)]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [_createElementVNode("img", {
    style: {
      "width": "347px"
    },
    src: "https://www.mimodental.com/assets/imgData/img/member_preferential/empty.png"
  }, null, -1)])))])]), _createVNode(_component_el_dialog, {
    modelValue: $setup.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.show = $event),
    width: "35%",
    "align-center": "",
    style: {
      "border-radius": "10px",
      "overflow": "hidden",
      "min-width": "530px"
    },
    "before-close": $setup.handleClose
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("h1", null, _toDisplayString($setup.cardRecordsList[$setup.preferential_tab_key].cardName), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
      src: $setup.cardRecordsList[$setup.preferential_tab_key].imgUrl,
      alt: ""
    }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, "有效时间：" + _toDisplayString($setup.cardRecordsList[$setup.preferential_tab_key].startdate + '至' + $setup.cardRecordsList[$setup.preferential_tab_key].indate), 1), _createElementVNode("span", null, "推荐人：" + _toDisplayString($setup.cardRecordsList[$setup.preferential_tab_key].referrer), 1)]), _createElementVNode("div", _hoisted_12, [_cache[4] || (_cache[4] = _createElementVNode("h3", null, "尊享项目", -1)), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dialog_data.welfares, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "display": "flex"
        },
        key: index
      }, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(item.details), 1)]);
    }), 128))])])])]),
    _: 1
  }, 8, ["modelValue", "before-close"])]);
}